var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#text_icon_svg__clip0_343_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.19 20.166v-.653a.83.83 0 00-.76-.828c-.33-.028-.66-.058-.99-.092-.635-.067-1.334-.137-1.334-.93V5.398a4.542 4.542 0 014.603 3.571.846.846 0 00.8.579h.667A.83.83 0 0021 8.716V3.832A.829.829 0 0020.172 3H3.828A.83.83 0 003 3.834V8.72a.829.829 0 00.828.831h.666a.846.846 0 00.801-.578A4.538 4.538 0 019.898 5.4v12.265c0 .793-.7.864-1.335.93-.329.034-.66.063-.988.092a.83.83 0 00-.76.827v.653a.829.829 0 00.828.832h8.722a.832.832 0 00.824-.834z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "text_icon_svg__clip0_343_101"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTextIcon;